import React, { Component } from "react";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import { Card, CardBody, Row, Col, Collapse } from "reactstrap";

class RearrangeQuestions extends Component {
  onDragEnd(result) {
    const { source, destination } = result;

    if (!destination) {
      return;
    }

    let new_questions_order = [].concat(this.props.questions);

    const [item_to_move] = new_questions_order.splice(source.index, 1);
    new_questions_order.splice(destination.index, 0, item_to_move);
    this.props.setOrderedQuestions(new_questions_order);
  }
  render() {
    const $questionsList = this.props.questions.map((question, index) => {
      return (
        <Draggable draggableId={index} index={index} key={index}>
          {provided => (
            <div ref={provided.innerRef} {...provided.draggableProps}>
              <Card className="question-answer-container">
                <CardBody>
                  <Row onClick={this.toggle}>
                    <Col xs="10">
                      <span className="question">{question.question}</span>{" "}
                      <span className="text-muted">
                        ({question.answers.length} options)
                      </span>
                    </Col>
                    <Col className="text-right">
                      <span
                        className="circular-icon icon-check ml-0"
                        {...provided.dragHandleProps}
                      >
                        <FontAwesomeIcon icon="arrows-alt" />
                      </span>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </div>
          )}
        </Draggable>
      );
    });
    return (
      <DragDropContext onDragEnd={this.onDragEnd.bind(this)}>
        <Droppable droppableId="droppable">
          {provided => (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              {$questionsList}
              <div id="questionList">{provided.placeholder}</div>
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  }
}

export default RearrangeQuestions;



// WEBPACK FOOTER //
// ./src/components/questions/modify/RearrangeQuestions.js